import React from "react";
import "./Stats.css"; // Create this CSS file for styles

// Font Awesome icons (alternative to React Icons)
import { FaSmile, FaFileAlt, FaHeadset, FaUsers } from "react-icons/fa";

const Stats = () => {
  const statsData = [
    { id: 1, icon: <FaSmile />, number: 232, text: "Happy Clients", color: "#FF9800" },
    { id: 2, icon: <FaFileAlt />, number: 521, text: "Projects", color: "#673AB7" },
    { id: 3, icon: <FaHeadset />, number: 24, text: "Hours of Support", color: "#009688" },
    { id: 4, icon: <FaUsers />, number: 30, text: "Hard Workers", color: "#3F51B5" },
  ];

  return (
    <div className="stats-container1">
      {statsData.map((stat) => (
        <div key={stat.id} className="stat-card1">
          <div className="stat-icon1" style={{ color: stat.color }}>
            {stat.icon}
          </div>
          <h2>{stat.number}</h2>
          <p>{stat.text}</p>
        </div>
      ))}
    </div>
  );
};

export default Stats;
